/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type ListingResponseDtoCurrencyCode = typeof ListingResponseDtoCurrencyCode[keyof typeof ListingResponseDtoCurrencyCode];


export const ListingResponseDtoCurrencyCode = {
  EUR: 'EUR',
} as const;
